import ErrorsList from '../../common/form/errors-list';

const FormErrorList = (props) => {
    const { form, field, ...otherProps } = props;
    const formField = form.fields[field] || { isValid: true };
    if (formField.isValid || !formField.isValidationEnabled) {
        return null;
    }
    return <ErrorsList errors={formField.errors} {...otherProps} />;
};

export default FormErrorList;
